
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertsAlarmTwotone as ObiAlertsAlarmTwotoneElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alerts-alarm-twotone.js';
 
 
 

 
 export const ObiAlertsAlarmTwotone = createComponent({
   react: React,
   tagName: 'obi-alerts-alarm-twotone',
   elementClass: ObiAlertsAlarmTwotoneElement,
   events: {
     
   }
  });
 
 